export default [
    {
        path: 'requisicao-pendente-permissao',
        component: () => import(
            /* webpackChunkName: 'almoxarifado-requisicao-pendente-permissao' */
            '@/views/almoxarifado/requisicao-pendente-permissao/Index'
        ),
        redirect: 'requisicao-pendente-permissao/index',
        children: [
            {
                name: 'almoxarifado-requisicao-pendente-permissao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-requisicao-pendente-permissao' */
                    '@/views/almoxarifado/requisicao-pendente-permissao/List.vue'
                ),
            },
            {
                name: 'almoxarifado-requisicao-pendente-permissao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'almoxarifado-requisicao-pendente-permissao' */
                    '@/views/almoxarifado/requisicao-pendente-permissao/Form.vue'
                ),
            },
        ],
    },
]